import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const RecommendationsIcon = (props: Omit<PosIconProps, 'viewBox'>) => {
  return (
    <SvgWrapper viewBox="0 0 14 14" {...props}>
      <path
        d="M4.6665 8.74935C7.51008 8.74935 8.74984 7.55293 8.74984 4.66602C8.74984 7.55293 9.9809 8.74935 12.8332 8.74935C9.9809 8.74935 8.74984 9.98042 8.74984 12.8327C8.74984 9.98042 7.51008 8.74935 4.6665 8.74935Z"
        fill={props.fill ?? 'white'}
        stroke={props.fill ?? 'white'}
        strokeWidth="0.875"
        strokeLinejoin="round"
      />
      <path
        d="M1.1665 3.79102C2.99453 3.79102 3.7915 3.02191 3.7915 1.16602C3.7915 3.02191 4.58291 3.79102 6.4165 3.79102C4.58291 3.79102 3.7915 4.58242 3.7915 6.41602C3.7915 4.58242 2.99453 3.79102 1.1665 3.79102Z"
        fill={props.fill ?? 'white'}
        stroke={props.fill ?? 'white'}
        strokeWidth="0.875"
        strokeLinejoin="round"
      />
    </SvgWrapper>
  );
};
